import React from 'react';
import _ from 'root/libs/exaforte/react/lodash';
import { View, Text, ActivityIndicator  } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TouchableArea from 'root/libs/exaforte/react/TouchableArea';
import { faChevronRight, faUndo, faChevronLeft, faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import { Button } from 'root/globals/Elements';
import { CustomCheckBox } from 'root/libs/exaforte/react/Form';
import CustomForm from 'root/libs/exaforte/react/form/CustomForm';

import defaults from 'root/globals/Defaults.less';
import custom_filter from './CustomFilter.less';

const styles = {...defaults, ...custom_filter};

export default class CustomFilter extends React.Component {
    render() {
        let filters_applied = _.size(this.props.controller.config.filter.get_filter());
        
        if(this.props.show)
            return <View className={['col-12 col-' + this.props.breakpoint + '-3 order-1 order-' + this.props.breakpoint + '-12 py-4 pl-' + this.props.breakpoint + '-4 pr-' + this.props.breakpoint + '-4', styles['filter'], styles['filter-' + this.props.breakpoint + '-responsive'], styles['background-color-light-blue-10']]}>
                    <TouchableArea onPress={this.props.toggleFilter} className={[styles['filter-arrow'], styles['position-absolute'], styles['color-light-blue'], styles['background-color-white'], 'd-flex align-items-center justify-content-center']}>
                        <FontAwesomeIcon icon={faChevronRight} className={'d-none d-' + this.props.breakpoint + '-block'} />
                        <FontAwesomeIcon icon={faChevronUp} className={'d-block d-' + this.props.breakpoint + '-none'} />
                    </TouchableArea>
                    <View className={['d-flex flex-row justify-content-between align-items-center mb-2']}>
                        <Text className={[styles['font-montserrat'], styles['text-bold'], styles['f-2-2-5']]}>Filter</Text>
                        <View className={'d-flex flex-row'}>
                            {filters_applied > 0 &&
                            <Button secondary={true} onPress={this.props.controller.config.filter.reset} className={['d-flex flex-row mr-2']}>
                                <Text className={['mr-2']}>Reset filter</Text>
                                <FontAwesomeIcon icon={faUndo} />
                            </Button>}
                            <Button onPress={this.props.loadData}>Herladen</Button>
                        </View>
                    </View>
                    {(!this.props.controller.initialized && this.props.controller.component.state.fetching) ? 
                        <View className={['d-flex justify-content-center mt-4']}>
                            <ActivityIndicator size={'lg'} />
                        </View>
                        :
                        <CustomForm model={this.props.controller.config.filter} fielddefines={this.props.controller.config.filter.get_fields()} />
                    }
                    {(_.size(this.props.controller.config.filter.get_fields()) >= 3) && <View className={['row my-3 pt-' + this.props.breakpoint + '-3 mb-lg-5 mb-lg-5']}>
                        <View className={['col-12 d-flex align-items-center justify-content-end']}>
                            {filters_applied > 0 && <Button secondary={true} onPress={this.props.controller.config.filter.reset} className={[styles['flex-direction-row'], styles['mr-1']]}>
                                <Text className={[styles['mr-1']]}>Reset filter</Text>
                                <FontAwesomeIcon icon={faUndo} />
                            </Button>}
                            <Button onPress={this.props.loadData}>Herladen</Button>
                        </View>
                    </View>}
                </View>;

        return <View className={['col-12 col-' + this.props.breakpoint + '-1 order-1 order-' + this.props.breakpoint + '-12 py-4', styles['filter'], styles['filter-' + this.props.breakpoint + '-responsive'], styles['background-color-light-blue-10'], styles['flex-align-items-center'], styles['flex-justify-content-center']]}>
                <TouchableArea onPress={this.props.toggleFilter} className={[styles['filter-arrow'], styles['position-absolute'], styles['color-light-blue'], styles['background-color-white'], 'd-flex align-items-center justify-content-center']}>
                    <FontAwesomeIcon icon={faChevronLeft} className={'d-none d-' + this.props.breakpoint + '-block'} />
                    <FontAwesomeIcon icon={faChevronDown} className={'d-block d-' + this.props.breakpoint + '-none'} />
                </TouchableArea>
                <View className={['d-flex align-items-center justify-content-between justify-content-' + this.props.breakpoint + '-center w-100']}>
                    <Text className={[styles['font-montserrat'], styles['text-bold'], styles['f-2-2-5'], styles['color-black'], 'd-block d-' + this.props.breakpoint + '-none']}>Filter</Text>
                    <Text className={[styles['f-3-5'], styles['text-color-bit-light-gray'], styles['text-light'], styles['filter-applied-text']]}>{filters_applied} filter{_.plural({amount: filters_applied, plural: 's'})} toegepast</Text>
                    {filters_applied > 0 &&
                    <Button secondary={true} onPress={this.props.controller.config.filter.reset} className={['flex-row d-flex d-' + this.props.breakpoint + '-none']}>
                        <Text className={['mr-1']}>Reset</Text>
                        <FontAwesomeIcon icon={faUndo} />
                    </Button>}
                </View>
            </View>;
    }
}
CustomFilter.defaultProps = {
    breakpoint: 'md'
}